import { defineMessages } from 'react-intl';

const messages = defineMessages({
  apartmentAdmin: {
    defaultMessage: `This user <strong>won't have access</strong> to Dormakaba locks.{br}Dormakaba lock require a 6-digit PIN. Contact your facility manager to update the PIN length, then regenerate the PIN to ensure access.`,
    id: 'AAmodal.alert.dormakaba',
  },
  siteAdmin: {
    defaultMessage: `This user <strong>won't have access</strong> to Dormakaba locks.{br} Dormakaba locks require a 6-digit PIN. Update the PIN length in <link>Site settings</link> and regenerate the PIN to ensure access.`,
    id: 'userPinModal.alert.dormakaba',
  },
});

export default messages;
